<template>
	<div>
		<header class="header-section">
			<div class="container-fluid p-0">
				<div class="header-wrapper" style="padding: 5px 40px">
					<div class="menu__left__wrap">
						<div class="logo-menu px-2">
								<!-- <router-link to="/" class="logo"> -->
									<img src="@/assets/img/logo.png" alt="logo">
								<!-- </router-link > -->
						</div>
					</div>
					<!-- <div class="mneu-btn-grp" v-if="!$store.state.authentication.loggedIn">
						<router-link to="/login" class="cmn--btn"><span>{{$store.state.lang.text.login[$store.state.lang.language]}}</span></router-link>
						<router-link to="/register" class="cmn--btn2"><span>{{$store.state.lang.text.register[$store.state.lang.language]}}</span></router-link>
					</div> -->
				</div>
			</div>
	   </header>
	</div>
</template>
<script>
	export default {
		data() {
			return {
			}
		},
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/HeaderPlay.vue